var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 17.1595 3.2565 21.558 7.82602 23.2536L8.86955 12L7.82602 0.746391C3.2565 2.44195 0 6.84042 0 12Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37262 18.6273 0 12 0C10.5321 0 9.12602 0.264047 7.82599 0.746391V23.2536C9.12602 23.736 10.5321 24 12 24C18.6273 24 24 18.6274 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82611 16.1739C10.1313 16.1739 12 14.3052 12 12C12 9.69483 10.1313 7.82611 7.82611 7.82611C5.52094 7.82611 3.65222 9.69483 3.65222 12C3.65222 14.3052 5.52094 16.1739 7.82611 16.1739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47827 9.91303V12.5217C5.47827 13.8184 6.5294 14.8695 7.8261 14.8695C9.1228 14.8695 10.1739 13.8184 10.1739 12.5217V9.91303H5.47827Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82608 13.3043C7.39455 13.3043 7.04346 12.9532 7.04346 12.5217V11.4783H8.60866V12.5218C8.60866 12.9532 8.25757 13.3043 7.82608 13.3043Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.7950209e99dcbe994174fe5262d4a01f.svg";
export { ForwardRef as ReactComponent };